import '../../App.css';
import React, { useContext, useEffect, useCallback, useState } from 'react';
import { ApiContext } from "../../context/ApiContext";
import Header from '../../components/header/Header';
import MenuLateral from '../../components/menu/MenuLateral'
import Footer from '../../components/footer/Footer'
import ModalEditarCiclo from '../../components/modal/ModalEditarCiclo';
import ModalExcluirCiclo from '../../components/modal/ModalExcluirCiclo';
import { IoIosWarning, IoIosCheckmarkCircle } from "react-icons/io";
import { FaPlus } from "react-icons/fa";
import { ColumnDirective, ColumnsDirective, GridComponent, Inject, Page, Toolbar, Sort } from '@syncfusion/ej2-react-grids';
import { L10n } from '@syncfusion/ej2-base';
import moment from 'moment/moment';
import { TbTrash, TbPencil } from "react-icons/tb";
import { StyleContext } from '../../context/StyleContext';
import ModalCriarCiclo from '../../components/modal/ModalCriarCiclo';
import Tabela from '../../components/Tabela';

function CadastroCiclo() {
    const { Success, Error, CiclosConsulta, ListaCiclosConsulta, modalEditarCiclo, setModalEditarCiclo, setEditarCiclo, setCicloAtualKey, loading, setModalExcluirCiclo, ExcluirCicloModal, setModalCriarCiclo, modalCriarCiclo, Permissao, ListaFiltroCiclo, totalRegistrosCiclo, filtroCiclo, totalRegistrosFiltroCiclo } = useContext(ApiContext)
    const { h3Demanda, corTerciaria, btnCriar } = useContext(StyleContext)

    const [currentPage, setCurrentPage] = useState(1);
    const [pageSize] = useState(10);
    const [searchTerm, setSearchTerm] = useState("");

    const EditCiclo = (props) => {
        setModalEditarCiclo(true)
        setCicloAtualKey(props.key)
        setEditarCiclo(props)
    }

    const DeletarCiclo = (props) => {
        setCicloAtualKey(props.key)
        setModalExcluirCiclo(true)
    }

    useEffect(() => {
        if (searchTerm.trim() !== "") {
            ListaFiltroCiclo(searchTerm, currentPage, pageSize);
        } else {
            ListaCiclosConsulta(currentPage, pageSize);
        }
    }, [currentPage, searchTerm]);

    const totalRegistros = searchTerm.trim() !== "" ? totalRegistrosFiltroCiclo : totalRegistrosCiclo;
    const totalPages = Math.max(1, Math.ceil((totalRegistros || 0) / pageSize));
    return (
        <div>
            <Header pagina={'Ciclos'}></Header>
            <MenuLateral></MenuLateral>
            {modalEditarCiclo &&
                <ModalEditarCiclo />
            }
            {Success &&
                <div className='success'>
                    <IoIosCheckmarkCircle className='error-icon' />{Success}
                </div>
            }
            {Error &&
                <div className='error'>
                    <IoIosWarning className='error-icon' />{Error}
                </div>
            }
            {ExcluirCicloModal &&
                <ModalExcluirCiclo />
            }
            <div className='container-principal'>
                <div className='demanda-header'>
                    {modalCriarCiclo &&
                        <ModalCriarCiclo closeModal={setModalCriarCiclo} />
                    }
                    {(!!Permissao.find(item => item.menu.descricao === "CADASTROS" && item.edicao === true)) &&
                        <button className='btn-dash btn-criar' style={btnCriar} onClick={() => setModalCriarCiclo(true)}><FaPlus style={{ marginRight: "10px" }} />Cadastrar ciclo</button>
                    }
                </div>
                {loading ? (
                    <div className="loading-screen">
                        <div className="loader-container">
                            <div className="spinner"></div>
                        </div>
                    </div>
                ) : (
                    <div className='card card-table'>
                        <h3 className='h3-demanda' style={h3Demanda}>Ciclos Cadastrados</h3>
                        <Tabela
                            data={searchTerm.trim() !== "" ? filtroCiclo : CiclosConsulta}
                            columns={[
                                { label: "Ciclo", field: "descricao", width: "20%" },
                                { label: "Data inicial", field: "dataInicial", width: "10%", render: (x) => moment(x.dataInicial).format("DD/MM/YYYY") || "-" },
                                { label: "Data final", field: "dataFinal", width: "10%", render: (x) => moment(x.dataFinal).format("DD/MM/YYYY") || "-" },
                                { label: "Observação", field: "observacao", width: "30%", render: (x) => x.observacao || "-" },
                                {
                                    label: "Opções",
                                    width: "10%",
                                    align: "center",
                                    render: (x) => (
                                        <div style={{ display: "flex", justifyContent: "center" }}>
                                            <button onClick={() => EditCiclo(x)} className='btn-dem' style={{ color: `${corTerciaria}` }}>
                                                <TbPencil />
                                            </button>
                                            {(!!Permissao.find(item => item.menu.descricao === "CADASTROS" && item.edicao === true)) &&
                                                <button onClick={() => DeletarCiclo(x)} className='btn-dem' style={{ color: `${corTerciaria}` }}>
                                                    <TbTrash />
                                                </button>
                                            }
                                        </div>
                                    ),
                                },
                            ]}
                            loading={loading}
                            currentPage={currentPage}
                            totalPages={totalPages}
                            setCurrentPage={setCurrentPage}
                            searchTerm={searchTerm}
                            setSearchTerm={setSearchTerm}
                            onSearch={(term) => {
                                setCurrentPage(1);
                                if (term.trim() !== "") {
                                    ListaFiltroCiclo(term, 1, 10);
                                } else {
                                    ListaCiclosConsulta(1, 10);
                                }
                            }}
                            corTerciaria={corTerciaria}
                        />
                    </div>
                )}
            </div>
            <Footer></Footer>
        </div>
    );
}

export default CadastroCiclo;